const List = () => import("@/pages/master/role/List")
const Form = () => import("@/pages/master/role/Form")
// import List from '@/pages/master/role/List'
// import Form from '@/pages/master/role/Form'
import layout from "@/layout/Master"

const data = [
  {
    path: "/master/role",
    name: "role-list",
    components: {
      content: List,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Role" },
        { title: "List", active: true }
      ],
      title: "Role List",
      module: "Role",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/master/role/create",
    name: "role-create",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Role" },
        { title: "Create", active: true }
      ],
      title: "Role Create",
      module: "Role",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/master/role/view/:id",
    name: "role-view",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Role" },
        { title: "View", active: true }
      ],
      title: "Role View",
      module: "Role",
      showLink: false,
      requiresAuth: true
    }
  },
  {
    path: "/master/role/edit/:id",
    name: "role-edit",
    components: {
      content: Form,
      layout: layout
    },
    meta: {
      breadcrumb: [
        { title: "Home", url: "/" },
        { title: "Role" },
        { title: "Edit", active: true }
      ],
      title: "Role Edit",
      module: "Role",
      showLink: false,
      requiresAuth: true
    }
  }
]
export default data
